import React from "react";
import { useFormikContext } from "formik";
import { usePendingPrefill, useSetDefaultValue } from "../../hooks";
import { emptyFunction } from "../../utils/helpers/emptyFunction";
import { CustomCheckbox } from "./checkbox";

export const PrefillCheckbox = React.forwardRef((props, ref) => {
  const {
    name, title, toolTipText, className, onBlur, hideErrors, children
  } = props;
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();

  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <CustomCheckbox
      title={title}
      ref={ref}
      onChange={handleChange}
      onBlur={(event) => {
        handleBlur(event);
        (onBlur || emptyFunction)(event);
      }}
      value={values[name]}
      name={name}
      toolTipText={toolTipText}
      className={className}
      errorMessage={touched[name] ? errors[name] : ""}
      hideErrors={hideErrors}
      children={children}
    />
  );
});